/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Web_Page_BlockedInputs */

const en_conversion_error_web_page_blocked = /** @type {(inputs: Conversion_Error_Web_Page_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This site blocks automated readers. Try saving the page as a PDF and uploading it.`)
};

const es_conversion_error_web_page_blocked = /** @type {(inputs: Conversion_Error_Web_Page_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este sitio bloquea los lectores automáticos. Intenta guardar la página como PDF y subirla.`)
};

/**
* | output |
* | --- |
* | "This site blocks automated readers. Try saving the page as a PDF and uploading it." |
*
* @param {Conversion_Error_Web_Page_BlockedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_web_page_blocked = /** @type {((inputs?: Conversion_Error_Web_Page_BlockedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Web_Page_BlockedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_web_page_blocked(inputs)
	return en_conversion_error_web_page_blocked(inputs)
});